<template>
  <BreadCrumb class="hidden sm:block" />
  <StoriesHomePage :entry="entry" :social-media-accounts="socialMediaAccounts" />
</template>

<script>
import gql from 'graphql-tag';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import StoriesHomePage, { StoriesHomePageFragment } from '@/components/stories/StoriesHomePage';
import { stripLocale } from '@/utils/i18n';
import { SocialMediaAccountsFragment } from '@/components/layout/footer/SocialMediaAccounts';
import { useEntryPage } from '@/composables/useEntryPage';
import BreadCrumb from '@/components/layout/BreadCrumb';

export const StoriesHomeQuery = gql`
  query StoriesHomeQuery($site: String!, $uri: String!) {
    entry(section: "stories", site: [$site], uri: [$uri]) {
      ...EntryPageFragment
      ...StoriesHomePageFragment
    }

    socialSet: globalSet(site: [$site], handle: "socialMediaAccounts") {
      ...SocialMediaAccountsFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }

  ${EntryPageFragment}
  ${StoriesHomePageFragment}
  ${SeomaticFragment}
  ${SocialMediaAccountsFragment}
`;

export default defineNuxtComponent({
  name: 'StoriesHomeController',

  components: { StoriesHomePage, BreadCrumb },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri };

    const {
      entry,
      seomatic,
      socialSet: { socialMediaAccounts },
    } = await $craftRequest(StoriesHomeQuery, variables);

    return { entry, seomatic, socialMediaAccounts };
  },
  data() {
    return { socialMediaAccounts: [] };
  },
  created() {
    useEntryPage(this.entry, this.seomatic, { content_category: 'stories' });
  },
});
</script>
